export const SLICE_NAME = 'lunaStreamsGroups';
